import { captureExceptionRateLimit } from '~/main/utils/exception-rate-limit';
import { getBrowserLocale, isCustomerCFD, isRenderProcess } from '~/renderer/utils';
import { getLanguage } from '~/shared/get-language';

import { cfdActions } from '../cfd';
import { hubActions } from '../hub';
import { StoreMiddleware } from '../index';

import type i18next from 'i18next';

// Gets the i18n module for either the main orr renderer process
const i18n: Promise<typeof i18next> =
  isRenderProcess && window.i18n
    ? Promise.resolve(window.i18n)
    : import('~/main/utils/i18n').then(({ default: defaultExport }) => defaultExport);

export const handleLocaleChange: StoreMiddleware = store => next => action => {
  if (isCustomerCFD) {
    i18n.then(locale => locale.changeLanguage(getBrowserLocale())).catch(captureExceptionRateLimit);
  } else if (cfdActions.updateOptions.match(action) && action.payload.locale) {
    i18n
      .then(locale =>
        locale.changeLanguage(getLanguage(store.getState().hub.language, action.payload.locale!)),
      )
      .catch(captureExceptionRateLimit);
  } else if (hubActions.updateLanguage.match(action)) {
    i18n
      .then(locale =>
        locale.changeLanguage(getLanguage(action.payload, store.getState().cfd.options.locale)),
      )
      .catch(captureExceptionRateLimit);
  }

  return next(action);
};
